import { AppBGColors, RewardsBGColors } from "../../Colors";
import styles from "../css/payments/renew-subscription-flow.module.css"
import priceStyles from '../css/payments/explore-pricing.module.css';
import { MonthlyPriceTileDesktop, MonthlyPriceTileMobile } from './pricingOptions/MonthlyPriceTile';
import { PremiumPriceTileDesktop, PremiumPriceTileMobile } from "./pricingOptions/PremiumPriceTile";
import { YearlyPriceTileDesktop, YearlyPriceTileMobile } from "./pricingOptions/YearlyPriceTile";
import Media from "react-media";

function ExplorePricing({ timeOfDay }) {

    const backgroundColors = {
        //'morning': AppBGColors.morning,
        'afternoon': AppBGColors.afternoon,
        //'evening': AppBGColors.evening,
    }

    return (
        <div className={`checkin ${styles.flowContainer}`} style={{ background: backgroundColors[timeOfDay] ?? RewardsBGColors[timeOfDay] }}>
            <h1 className={`${styles.headingPrimary} ${priceStyles.screenHeading}`}>
                How can we support you?
            </h1>
            <>
                <Media queries={{
                    small: "(max-width: 964px)",
                    default: "(min-width: 965px)"
                }}>
                    {matches => (
                        <>
                            {matches.small && (
                                <div className={`answer-input-div ${priceStyles.pricesContainer}`} style={{ flexDirection: "column", marginBottom: "2.5rem" }}>
                                    <MonthlyPriceTileMobile timeOfDay={timeOfDay} />
                                    <PremiumPriceTileMobile timeOfDay={timeOfDay} />
                                    <YearlyPriceTileMobile timeOfDay={timeOfDay} />
                                </div>
                            )}
                            {matches.default && (
                                <div className={`answer-input-div ${priceStyles.pricesContainer}`}>
                                    <MonthlyPriceTileDesktop timeOfDay={timeOfDay} />
                                    <PremiumPriceTileDesktop timeOfDay={timeOfDay} />
                                    <YearlyPriceTileDesktop timeOfDay={timeOfDay} />
                                </div>
                            )}
                        </>
                    )}
                </Media>
            </>
        </div >
    )
}

export default ExplorePricing;
